'use client';

import React from 'react';

import useDownloadReportForm from './hooks/useDownloadReportForm';

import Typography from '@/components/_ui/Typography/Typography';
import Button from '@/components/_ui/Buttons/Button/Button';
import Icon from '../_ui/Icon/Icon';
import Divider from '../HybridDropdown/Divider/Divider';
import DateRange from './FieldSets/DateRange/DateRange';
import ApplicationsSelector from './FieldSets/ApplicationsSelector/ApplicationsSelector';
import ContractSelector from './FieldSets/ContractSelector/ContractSelector';
import CustomerSelector from './FieldSets/CustomerSelector/CustomerSelector';

interface Props {
    onClose: () => void;
}

const CreateReportModal = ({ onClose }: Props) => {
    const {
        formData,
        setFormData,
        formState,
        formPending,
        handleSubmitForm,
    } = useDownloadReportForm();

    const dateRangeErrors = [
        formState.errors?.start_date?.length ? formState.errors.start_date[0] : '',
        formState.errors?.end_date?.length ? formState.errors.end_date[0] : ''
    ].filter(Boolean);

    return (
        <>
            <div className="space-y-150 w-screen max-w-[19rem]" id="create-report-modal">
                <div className="flex items-center justify-between">
                    <Typography as="h2" variant="subHeading" fontSize="100" className="text-xl font-semibold">
                        Create report
                    </Typography>
                    <Button variant="none" className="p-0" onClick={onClose}>
                        <Icon icon="cross" />
                    </Button>
                </div>
                <form action={handleSubmitForm} className="space-y-200">
                    <DateRange
                        formData={formData}
                        setFormData={setFormData}
                        errorMessage={dateRangeErrors.length ? dateRangeErrors.join(' ') : ''}
                    />
                    <Divider />
                    <CustomerSelector
                        formData={formData}
                        setFormData={setFormData}
                        errorMessage={formState.errors?.customers?.length ? formState.errors.customers[0] : ''}
                        className="relative z-20"
                    />
                    <Divider />
                    <ContractSelector
                        formData={formData}
                        setFormData={setFormData}
                        errorMessage={formState.errors?.contracts?.length ? formState.errors.contracts[0] : ''}
                    />
                    <Divider />
                    <ApplicationsSelector
                        formData={formData}
                        setFormData={setFormData}
                        errorMessage={formState.errors?.applications?.length ? formState.errors?.applications[0] : ''}
                    />
                    <Divider />
                    <div className="flex flex-row gap-150 justify-end">
                        <Button onClick={onClose} variant="primaryBorder" disabled={formPending}>Cancel</Button>
                        <Button type="submit" loading={formPending} disabled={formPending}>
                            Create Report
                        </Button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default CreateReportModal;
